import { baseHeaders } from "./Headers";
import { doGetExternalAppRequest } from "./ApiService";

export function getAddress(zipCode: string): Promise<any> {
  const url = `/address/zip-code/${zipCode.replace("-", "")}?gw-app-key=${
    process.env.VUE_APP_X_GW_APP_KEY
  }`;
  const headers = {
    ...baseHeaders,
  };
  return doGetExternalAppRequest(url, headers);
}
